import {loadFrase} from '../helpers/frase'

const FRASE_LOADED = '[FRASE LD] FRASE LOADED'
const FRASE_UPDATE = '[FRASE LD] FRASE UPDATE'
const FRASE_CLEANING = '[FRASE LD] FRASE CLEANING'

export const startLoadingFrase = (puid) => {
    return async (dispatch) => {
        const dataFrase = await loadFrase(puid);
        const {sentence, uid} = dataFrase[0];

        dispatch(setFrase(uid,sentence))
    }
}

const setFrase = (uid, sentence) => ({
    type: FRASE_LOADED,
    payload: {
        uid,
        sentence
    }
})


export const refreshFrase = (sentence, uid) => ({
    type: FRASE_UPDATE,
    payload: {
        uid,
        sentence
    }
})

export const fraseLogout = () => ({
    type: FRASE_CLEANING,
})

export const fraseDelDiaReducer = (state = {}, action) => {
    switch (action.type) {

        case FRASE_LOADED:
            return {
                sentence: action.payload.sentence,
                uid: action.payload.uid
            }
        case FRASE_UPDATE:
            return {
                ...state,
                sentence: action.payload.sentence,
                uid: action.payload.uid
            }
        case FRASE_CLEANING:
            return {}
        default:
            return state;
    }
}